import React, {useState} from 'react';
import ReactDOM from 'react-dom';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import rootReducer from './store/reducers/root';
import rootSaga from './store/sagas/root';
import createSagaMiddleware from 'redux-saga';
import {connect} from 'react-redux';
import App from './MainApp';
import {MuiThemeProvider} from'@material-ui/core/styles';
import {dynamicallyBuildTheme} from './Themes';
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import {ErrorBoundary} from './components';
import pako from 'pako';



const sagaMiddleware = createSagaMiddleware();
const store=createStore(rootReducer, applyMiddleware(sagaMiddleware));
sagaMiddleware.run(rootSaga);



navigator.serviceWorker && navigator.serviceWorker.register('/sw.js').then(function(registration) {  console.log(registration.scope);});
window.createStream=(jsonPayload)=>{
  const jsonString = JSON.stringify(jsonPayload);
   const compressedData = pako.gzip(jsonString);
  const blob = new Blob([compressedData], { type: 'application/octet-stream' });
  const formData = new FormData();
  formData.append('file', blob, 'data.json');
  return formData;
}


window.capitalizeFirstLetter=(inputString)=>{
  if (typeof inputString !== 'string' || inputString.length === 0) {
    // Handle edge cases here, such as when the input is not a string or is an empty string.
    return inputString; // Return the input as is in these cases.
  }

  return inputString.charAt(0).toUpperCase() + inputString.slice(1);
}

window.getDateTimeHere=(datee)=>{
  if(datee!=null && datee!=undefined){
    if (typeof datee !== 'string') {
      datee = String(datee);
    }
    datee=datee.replace('Z', '');
    let d = new Date(datee); let n = d.getTimezoneOffset(); d.setHours(d.getHours()-(n/60));
    let year = d.getFullYear(); let month =("0" + (d.getMonth() + 1)).slice(-2); let date = ("0" + d.getDate()).slice(-2); let hours= ("0" + d.getHours()).slice(-2); let minutes=("0" + d.getMinutes()).slice(-2); let seconds=("0" + d.getSeconds()).slice(-2);
    return year+'-'+month+'-'+date+' '+hours+':'+minutes+':'+seconds;
}}

window.isValidUrl=function(url, tlds=null) {
  // Regular expression for validating URL
  const urlRegex =/^(?:(?:https?|ftp):\/\/)?([^\s.]+\.\S{2}|localhost[\:?\d]*)\S*$/;
  if(urlRegex.test(url)==true){
    if(tlds!=null){let urlRegex_2 = /^(?:(?:https?|ftp):\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:/\n?]+)\S*$/;
      let matches = url.match(urlRegex_2);
      if (matches) {let domain = matches[1]; let lastDotIndex = domain.lastIndexOf('.');
      let tld = domain.substring(lastDotIndex + 1).toLowerCase();
      if (!tlds.includes(tld)) {return false;} console.log('TRUE', tld); return true;}
      return false;
    } return true;
  }
}

window.removeHTMLTags = function (content, asterix_and_underscore=false, short_codes=false) {
  // Create a temporary div to strip the HTML tags
  let div = document.createElement('div');
  div.innerHTML = content;

  let text = div.innerHTML;

  if(short_codes==true){
    text = text.replace(/<a [^>]*href="([^"]+)"[^>]*>(.*?)<\/a>/gi, "$2 ($1)");
  }else{
        // Replace <br> tags with newline characters (\n)
        text = text.replace(/<br\s*\/?>/gi, "\n");

        text = text.replace(/&nbsp;/gi, " ");

        // Handle <p> tags by turning them into a double newline (paragraph break)
        text = text.replace(/<\/?p>/gi, "\n\n");

        // Handle <pre> and <code> tags by preserving white spaces (optional)
        text = text.replace(/<pre.*?>(.*?)<\/pre>/gis, function (match, p1) {
          return p1.replace(/</g, '&lt;').replace(/>/g, '&gt;');
        });
        text = text.replace(/<code.*?>(.*?)<\/code>/gis, function (match, p1) {
          return p1.replace(/</g, '&lt;').replace(/>/g, '&gt;');
        });

        if(asterix_and_underscore==true){
          // Convert <strong> and <b> to *bold*
          text = text.replace(/<strong>(.*?)<\/strong>/gi, "*$1*");
          text = text.replace(/<b>(.*?)<\/b>/gi, "*$1*");
        }else{
          text = text.replace(/<strong>(.*?)<\/strong>/gi, function (match, p1) { return p1.toUpperCase(); });
          text = text.replace(/<b>(.*?)<\/b>/gi, function (match, p1) { return p1.toUpperCase(); });
        }

        
        if(asterix_and_underscore==true){
          // Convert <em> and <i> to _italic_
          text = text.replace(/<em>(.*?)<\/em>/gi, "_$1_");
          text = text.replace(/<i>(.*?)<\/i>/gi, "_$1_");
        }else{
          // Convert <em> and <i> tags to "italic" style with quotation marks
          text = text.replace(/<em>(.*?)<\/em>/gi, '"$1"');
          text = text.replace(/<i>(.*?)<\/i>/gi, '"$1"');
        }


        // Handle <ul> and <ol> lists and <li> items
        text = text.replace(/<ul>/gi, "\n"); // Start of an unordered list
        text = text.replace(/<\/ul>/gi, "\n"); // End of an unordered list
        text = text.replace(/<ol>/gi, "\n"); // Start of an ordered list
        text = text.replace(/<\/ol>/gi, "\n"); // End of an ordered list
        text = text.replace(/<li>/gi, "- "); // Convert list items to bullet points
        text = text.replace(/<\/li>/gi, "\n"); // End each list item with a newline

        // Handle <h1>, <h2>, <h3> headers as Markdown headers
        text = text.replace(/<h1>(.*?)<\/h1>/gi, "# $1");
        text = text.replace(/<h2>(.*?)<\/h2>/gi, "## $1");
        text = text.replace(/<h3>(.*?)<\/h3>/gi, "### $1");

        // Remove all other HTML tags, but preserve line breaks
        text = text.replace(/<\/?[^>]+(>|$)/g, "").trim();

        // Normalize any sequence of newlines to a single \n
        text = text.replace(/\n+/g, '\n');
          // Decode special HTML characters (e.g., &lt;, &gt;, &amp;)
          text = text.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&')
            .replace(/&quot;/g, '"').replace(/&#39;/g, "'");
  }

  return text;
}




window.getCountry=function(id, countries){if(countries!=undefined){for(let c of countries){if(c.id==id){return c.name;}}}}


window.isValidPhoneNumber=function(phoneNumber, country=undefined, local_country=undefined){
  phoneNumber=phoneNumber.split('ext')[0].replace(/[^0-9+]/g, '');
  let cleanedNumber = phoneNumber.replace(/[^\d]/g, '');
  if(cleanedNumber.length>=5 && cleanedNumber.length<=15){
    //DONT USE CLEANED NUMBER, SO THAT WE CAN KEEP + FOR TESTING
    const phoneUtil = window.libphonenumber.PhoneNumberUtil.getInstance(); try {const parsedNumber = phoneUtil.parse(phoneNumber); let result=phoneUtil.isValidNumber(parsedNumber); if(result==true){return true;}else{throw new Error('Try American')}} catch (error) {
      try {let result=false; if(country!=undefined){const parsedNumber = phoneUtil.parse(phoneNumber, country); result=phoneUtil.isValidNumber(parsedNumber);} if(result==true){return true;}else{throw new Error('Try American')}} catch (error) {
        try {let result=false; const parsedNumber = phoneUtil.parse(phoneNumber, 'US'); result=phoneUtil.isValidNumber(parsedNumber); if(result==true){return true;}else{throw new Error('Try American')}} catch (error) {
          try {let result=false; if(local_country!=undefined){const parsedNumber = phoneUtil.parse(phoneNumber, local_country); result=phoneUtil.isValidNumber(parsedNumber);} if(result==true){return true;}else{throw new Error('Try American')}} catch (error) {
            //const pattern = /^(?:\+?1)?[2-9]\d{2}[2-9](?!11)\d{6}$/;
            const cleanedNumber = phoneNumber.split('ext')[0].replace(/[^\d]/g, ''); // Remove non-digit characters
            //if(pattern.test(cleanedNumber)==true){return true;};
            if(cleanedNumber.length>=7 && cleanedNumber.length<=12){return 'loose';}
    }}}}
  } return false;
}



window.isValidEmail=function(email){
  const emailRegex =/^[^\s@]+@[^\s@]+\.[^\s@]+$/; return emailRegex.test(email);
}


window.isValidDate=function(date){
  return false;
}

window.isValidInteger=function(int){
  return false;
}

window.getQuickEmailStatus=function(contact_email, no_skip_generic=true){
  if(contact_email==undefined){return {value:'UNKNOWN', enum:'email_verification_status'};}
  let es=contact_email.email_status;
  let enumo='email_status';
  if(es==undefined || es=='NONE' || es=='UNKNOWN'){
    enumo='email_verification_status';
    es=contact_email.email.tomba_verification_status;
    es=(es=='UNKNOWN' || es==null)?contact_email.email.email_verification_status:es;
    if(es!='INVALID' && es!='VERIFIED'){
      if(contact_email.email.email_type!='BUSINESS' && (contact_email.email.email_type!='GENERIC' || no_skip_generic==true)){enumo='email_type'; es=contact_email.email.email_type;}
      if(contact_email.email.is_catchall==true){es='ACCEPT_ALL';}
    }
  }
  if(es==undefined){es='UNKNOWN'}
  return {value:es, enum:enumo};
}

window.isScoringAccountNonAdmin=function(workspace, user){if(workspace==undefined || user==undefined){return false;} return (isScoringAccount(workspace)==true && user.id!=201 && user.id!=2 && user.id!=2)}
window.isScoringAccount=function(workspace){if(workspace==undefined){return false;} return (workspace.id==429 || ((window.location.href.includes('test.prospectsafari.com')==true || window.location.href.includes('localhost:')==true)  && workspace.id==395))}
window.isJumpstartCustomer=function(workspace){if(workspace!=undefined && workspace.customer_of_special_services!=undefined){for(let w of workspace.customer_of_special_services){if(w.workspace_default_special_service_id==1){return true;}}} return false;}


window.getAddonUser=function(me, workspace, subscriptions, id){
  if(workspace!=undefined && me!=undefined && workspace.active_subscription!=undefined && subscriptions!=undefined){
  console.log(workspace, id, subscriptions, me);
  for(let ae of workspace.active_subscription.active_subscription_extras){
    for(let s of subscriptions){
      if(ae.prospect_safari_service_id==s.id && s.recognise==id){
        for(let uw of ae.user_workspaces){if(uw.id==me.user_workspace_id){return s;break;}}
}}}}}

window.libphonenumber = require('google-libphonenumber');

window.onerror=function(msg, url, line, col, error){
  console.log(msg);
}


window.getTimezone=function(){
  const today = new Date();
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return timezone;
}

window.getCrmIntegration=function(company, workspace, crm_type){let crm_login=undefined; if(workspace==undefined || company==undefined || workspace.crm_logins==undefined || company.crm_integrations==undefined){return undefined} for(let cl of workspace.crm_logins){if(cl.crm_type=='HUBSPOT'){crm_login=cl;}} if(crm_login!=undefined){for(let ci of company.crm_integrations){if(ci.crm_login_id==crm_login.id){return ci;}}}}
window.getCrmLogin=function(workspace, crm_type){if(workspace==undefined || workspace.crm_logins==undefined){return undefined} for(let cl of workspace.crm_logins){if(cl.crm_type=='HUBSPOT'){return cl;}}}

window.OldGetTimezone=function(){
  const today = new Date();
  const short = today.toLocaleDateString(undefined);
  const full = today.toLocaleDateString(undefined, { timeZoneName: 'short' });

  // Trying to remove date from the string in a locale-agnostic way
  const shortIndex = full.indexOf(short);
  if (shortIndex >= 0) {
    const trimmed = full.substring(0, shortIndex) + full.substring(shortIndex + short.length);

    // by this time `trimmed` should be the timezone's name with some punctuation -
    // trim it from both sides
    return trimmed.replace(/^[\s,.\-:;]+|[\s,.\-:;]+$/g, '');

  } else {
    // in some magic case when short representation of date is not present in the long one, just return the long one as a fallback, since it should contain the timezone's name
    return full;
  }
}



if (document.getElementById('react')) {
    ReactDOM.render(<Provider store={store}><Sub/></Provider>, document.getElementById('react'));

}



function Sub(props){
  const[workspace, setWorkspace]=useState(undefined)
  let theme=dynamicallyBuildTheme((workspace==undefined && window.location.href.includes('/specialLoginProcessForceUpload/gjytsirysjfghvvcmgseafhdjhgvk')==true)?{background_colour:'#e4e4e4', primary_colour:'#d62d22', tertiary_colour:'#323232', secondary_colour:'#000000'}:workspace);
  return(
    <MuiThemeProvider theme={theme}><DndProvider backend={HTML5Backend}><App setWorkspace={setWorkspace}/></DndProvider></MuiThemeProvider>
  )
}

//cool
